import { defineMessages } from 'react-intl'

const messages = defineMessages({
  mainInfoTitle: {
    id: 'tenantSettings.userManagement.users.mainInfoTitle',
    description: 'Main Info Title',
    defaultMessage: 'Main Info',
  },
  nameLabel: {
    id: 'tenantSettings.userManagement.users.nameLabel',
    description: 'Name label',
    defaultMessage: 'Name',
  },
  firstNameLabel: {
    id: 'tenantSettings.userManagement.users.firstNameLabel',
    description: 'First Name label',
    defaultMessage: 'First Name',
  },
  lastNameLabel: {
    id: 'tenantSettings.userManagement.users.lastNameLabel',
    description: 'Last Name label',
    defaultMessage: 'Last Name',
  },
  emailLabel: {
    id: 'tenantSettings.userManagement.users.emailLabel',
    description: 'Email label',
    defaultMessage: 'Email',
  },
  phoneLabel: {
    id: 'tenantSettings.userManagement.users.phoneLabel',
    description: 'Phone label',
    defaultMessage: 'Mobile Phone',
  },
  systemUserLabel: {
    id: 'tenantSettings.userManagement.users.systemUserLabel',
    description: 'System user type label',
    defaultMessage: 'System',
  },
  workforceUserLabel: {
    id: 'tenantSettings.userManagement.users.workforceUserLabel',
    description: 'Workforce User type label',
    defaultMessage: 'Workforce',
  },
  userType: {
    id: 'tenantSettings.userManagement.users.userType',
    description: 'User Type',
    defaultMessage: 'User Type',
  },
  descriptionLabel: {
    id: 'tenantSettings.userManagement.users.descriptionLabel',
    description: 'Description label',
    defaultMessage: 'Description',
  },
  nameIsRequired: {
    id: 'tenantSettings.userManagement.users.nameIsRequired',
    description: 'Name is required',
    defaultMessage: 'Name is required',
  },
  descriptionIsRequired: {
    id: 'tenantSettings.userManagement.users.descriptionIsRequired',
    description: 'Description is required',
    defaultMessage: 'Description is required',
  },
  activeLabel: {
    id: 'tenantSettings.userManagement.users.activeLabel',
    description: 'Active label',
    defaultMessage: 'Active',
  },
  yesLabel: {
    id: 'tenantSettings.userManagement.users.yesLabel',
    description: 'Yes label',
    defaultMessage: 'Yes',
  },
  noLabel: {
    id: 'tenantSettings.userManagement.users.noLabel',
    description: 'No label',
    defaultMessage: 'No',
  },
  createUserLabel: {
    id: 'tenantSettings.userManagement.users.createUserLabel',
    description: 'Create user label',
    defaultMessage: 'Create User',
  },
  editUserLabel: {
    id: 'tenantSettings.userManagement.users.editUserLabel',
    description: 'Edit user label',
    defaultMessage: 'Edit',
  },
  viewUserLabel: {
    id: 'tenantSettings.userManagement.users.viewUserLabel',
    description: 'View user label',
    defaultMessage: 'View',
  },
  newUserLabel: {
    id: 'tenantSettings.userManagement.users.newUserLabel',
    description: 'New user label',
    defaultMessage: 'New User',
  },
  cancelBtn: {
    id: 'tenantSettings.userManagement.users.cancelBtn',
    description: 'Cancel button',
    defaultMessage: 'Cancel',
  },
  editBtn: {
    id: 'tenantSettings.userManagement.users.editBtn',
    description: 'Edit button',
    defaultMessage: 'Edit',
  },
  activeLbl: {
    id: 'tenantSettings.userManagement.users.activeLbl',
    description: 'Active label',
    defaultMessage: 'Active',
  },
  firstNameIsRequired: {
    id: 'tenantSettings.userManagement.users.firstNameIsRequired',
    description: 'First Name is required',
    defaultMessage: 'First Name is required',
  },
  lastNameIsRequired: {
    id: 'tenantSettings.userManagement.users.lastNameIsRequired',
    description: 'Last Name is required',
    defaultMessage: 'Last Name is required',
  },
  emailIsRequired: {
    id: 'tenantSettings.userManagement.users.emailIsRequired',
    description: 'Email is required',
    defaultMessage: 'Email is required',
  },
  phoneIsRequired: {
    id: 'tenantSettings.userManagement.users.phoneIsRequired',
    description: 'Phone is required',
    defaultMessage: 'Phone is required',
  },
  userTypeIsRequired: {
    id: 'tenantSettings.userManagement.users.userTypeIsRequired',
    description: 'User Type is required',
    defaultMessage: 'User Type is required',
  },
  userCreated: {
    id: 'tenantSettings.userManagement.users.userCreated',
    description: 'User Created API msg',
    defaultMessage: 'User Created',
  },
  userUpdated: {
    id: 'tenantSettings.userManagement.users.userUpdated',
    description: 'User Type is required',
    defaultMessage: 'User Updated',
  },
  userApiError: {
    id: 'tenantSettings.userManagement.users.userApiError',
    description: 'BE return API unhandled error',
    defaultMessage: 'Something went wrong, try again later ',
  },
  // E10 F10-7 — invitation lifecycle
  statusLabel: {
    id: 'tenantSettings.userManagement.users.statusLabel',
    description: 'Status column header',
    defaultMessage: 'Status',
  },
  statusActive: {
    id: 'tenantSettings.userManagement.users.statusActive',
    description: 'Active status',
    defaultMessage: 'Active',
  },
  statusInvited: {
    id: 'tenantSettings.userManagement.users.statusInvited',
    description: 'Invited status',
    defaultMessage: 'Invited',
  },
  statusExpired: {
    id: 'tenantSettings.userManagement.users.statusExpired',
    description: 'Expired status',
    defaultMessage: 'Invite expired',
  },
  statusDisabled: {
    id: 'tenantSettings.userManagement.users.statusDisabled',
    description: 'Disabled status',
    defaultMessage: 'Disabled',
  },
  inviteUserButton: {
    id: 'tenantSettings.userManagement.users.inviteUserButton',
    description: 'Invite user button',
    defaultMessage: 'Invite user',
  },
  inviteUserSectionTitle: {
    id: 'tenantSettings.userManagement.users.inviteUserSectionTitle',
    description: 'Invite user modal section title',
    defaultMessage: 'Invite user',
  },
  inviteUserSuccess: {
    id: 'tenantSettings.userManagement.users.inviteUserSuccess',
    description: 'Invite user success toast',
    defaultMessage: 'Invitation sent',
  },
  inviteExpiryLabel: {
    id: 'tenantSettings.userManagement.users.inviteExpiryLabel',
    description: 'Invitation expiry field label',
    defaultMessage: 'Invitation expires after',
  },
  inviteExpiry1Day: {
    id: 'tenantSettings.userManagement.users.inviteExpiry1Day',
    description: '1 day expiry option',
    defaultMessage: '1 day',
  },
  inviteExpiry3Days: {
    id: 'tenantSettings.userManagement.users.inviteExpiry3Days',
    description: '3 days expiry option',
    defaultMessage: '3 days',
  },
  inviteExpiry7Days: {
    id: 'tenantSettings.userManagement.users.inviteExpiry7Days',
    description: '7 days expiry option',
    defaultMessage: '7 days',
  },
  duplicateEmailInScope: {
    id: 'tenantSettings.userManagement.users.duplicateEmailInScope',
    description: 'Duplicate email inline error',
    defaultMessage: 'A user with this email already exists in this workspace',
  },
  resendInvite: {
    id: 'tenantSettings.userManagement.users.resendInvite',
    description: 'Resend invitation row action',
    defaultMessage: 'Resend invitation',
  },
  revokeInvite: {
    id: 'tenantSettings.userManagement.users.revokeInvite',
    description: 'Revoke invitation row action',
    defaultMessage: 'Revoke invitation',
  },
  resendInviteSuccess: {
    id: 'tenantSettings.userManagement.users.resendInviteSuccess',
    description: 'Resend invitation success toast',
    defaultMessage: 'Invitation resent',
  },
  revokeInviteSuccess: {
    id: 'tenantSettings.userManagement.users.revokeInviteSuccess',
    description: 'Revoke invitation success toast',
    defaultMessage: 'Invitation revoked',
  },
  revokeInviteConfirm: {
    id: 'tenantSettings.userManagement.users.revokeInviteConfirm',
    description: 'Revoke invitation confirm prompt',
    defaultMessage: 'Revoke this invitation? The pending user will no longer be able to sign in.',
  },
})

export default messages
